import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/#collections", label: "Collections" },
  { to: "/tarot", label: "Tarot Readings" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="moonspirit home">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[13px] uppercase tracking-widest2 transition-colors duration-300 hover:text-gold ${
                  isActive ? "text-gold" : "text-mist"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/tarot"
            data-testid="nav-reading-cta"
            className="hidden md:inline-flex items-center rounded-full bg-gold px-5 py-2 text-[13px] font-semibold uppercase tracking-widest2 text-ink transition-colors duration-300 hover:bg-paper"
          >
            Book a reading
          </Link>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="hidden md:inline-flex text-[12px] uppercase tracking-widest2 text-mist/60 transition-colors duration-300 hover:text-gold"
          >
            Keeper&rsquo;s desk
          </Link>
          <button
            data-testid="mobile-menu-button"
            className="md:hidden text-paper p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden bg-black/90 backdrop-blur-xl border-b border-white/10"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.concat([{ to: "/admin", label: "Keeper's Desk" }]).map((n) => (
                <NavLink
                  key={n.to + n.label}
                  to={n.to}
                  data-testid={`mobile-link-${n.label.toLowerCase().replace(/\s+/g, "-").replace(/'/g, "")}`}
                  onClick={() => setOpen(false)}
                  className="font-display text-2xl text-paper hover:text-gold transition-colors duration-300"
                >
                  {n.label}
                </NavLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
